export const EntityType = {
    CONTACT: 0,
    ASSET: 1,
    DEAL: 2,
  };
  
  export const SOURCE_CDX = 'CDX';
  export const SOURCES_REDIRECT_FINAL_PAGE = ['ThankyouPage', 'InitialCommunication'];
  export const SOURCES_REDIRECT_FINAL_PAGE_PHOENIX = 'Phoenix';
  